export default __webpack_public_path__ + "static/media/striptheme.99d59ff5.png";